import { Outlet } from "react-router-dom";
import Logo from "../components/Logo";

const isMaintenance = import.meta.env.VITE_IS_MAINTENANCE;

export const Maintenance = () => {
	if (isMaintenance !== "true") {
		return <Outlet />;
	}

	return (
		<div
			className="auth-container uk-flex uk-flex-middle uk-flex-center uk-text-center"
			style={{ minHeight: "100svh" }}
		>
			<div>
				<Logo size="large" />
				<div className="uk-card uk-card-default uk-card-body">
					<div className="uk-width-large">
						<h1>Przerwa Techniczna</h1>
						<h3 className="uk-margin-top">
							Przepraszamy, nasza strona jest obecnie niedostępna z powodu prac
							konserwacyjnych. Wrócimy wkrótce!
						</h3>
					</div>
				</div>
			</div>
		</div>
	);
};
